import axios from 'axios';
import {clearAlerts, setAlert} from './alert';
import {
    CLEAR_ERRORS,
    GET_SUPPLIER_TRANSACTIONS, GET_SUPPLIERS_TRANSACTIONS, SET_LOADING, SUPPLIER_ERROR,
    SUPPLIER_TRANSACTION_ERROR, UNSET_LOADING
} from './types';
import {request} from "../utils/service";

export const setLoading = () => (dispatch) => {
    dispatch({
        type: SET_LOADING,
    });
};
export const unsetLoading = () => (dispatch) => {
    dispatch({
        type: UNSET_LOADING,
    });
};

// getRowData after update in table
export const getSuppliersTransactions = (page = 1, filters = {}) => async (dispatch) => {
    dispatch(setLoading());
    dispatch(clearAlerts());
    let queryParams = '';
    if (filters) {
        Object.keys(filters).map((key) => queryParams += `&${key}=${filters[key]}`);
    }

    const res = await request(`/supplier-transactions/?page=${page}${queryParams}`, {method: 'GET'}, dispatch);


    if (res.hasOwnProperty('errors')) {
        const err = res.errors;
        dispatch(setAlert(err.response.statusText, 'danger'));
        dispatch(unsetLoading());
    } else {
        dispatch({
            type: GET_SUPPLIERS_TRANSACTIONS,
            payload: res
        });
    }
};

// getRowData after update in table
export const getSupplierTransactions = (supplier_id, filters = {}) => async (dispatch) => {
    dispatch(setLoading());
    
    let queryParams = '';
    if (filters) {
        Object.keys(filters).map((key) => queryParams += `&${key}=${filters[key]}`);
    }
    
    // Add page parameter if not present in filters
    if (!filters.page && !queryParams.includes('page=')) {
        queryParams += '&page=1';
    }
    
    // Add per_page parameter if not present
    if (!filters.per_page && !queryParams.includes('per_page=')) {
        queryParams += '&per_page=10';
    }
    
    const res = await request(`/single-supplier-transactions/${supplier_id}?${queryParams}`, {method: 'GET'}, dispatch);

    if (res && res.hasOwnProperty('errors')) {
        const err = res.errors;
        dispatch(setAlert(err.response.statusText, 'danger'));
        dispatch({
            type: SUPPLIER_ERROR,
            payload: err,
        });
    } else {
        dispatch({
            type: GET_SUPPLIER_TRANSACTIONS,
            payload: res
        });
        dispatch(unsetLoading());
    }
};


export const addOrUpdateSupplierTransaction = (formData, filters = {}) => async (dispatch) => {
    dispatch(clearAlerts());
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    try {
        await axios.put('/add-or-update-supplier-transaction/', formData, config);
        dispatch(setAlert('Tranzaksiya amalga oshirildi!', 'success'));
        dispatch(getSupplierTransactions(formData.supplier_id, filters));
        dispatch(getSuppliersTransactions(1, filters));
        return true;
    } catch (err) {
        dispatch(setAlert("Yetkazuvchi balansiga tranzaksiya amalga oshirilmadi!", 'danger'));
        dispatch({
            type: SUPPLIER_TRANSACTION_ERROR,
            payload: err.response.data,
        });
    }
};


// download report
export const downloadSupplierReport = (filters = {}) => async (dispatch) => {
    dispatch(setLoading());
    dispatch(clearAlerts());
    let queryParams = '?';
    if (filters) {
        Object.keys(filters).map((key, index) => index === 0 ? queryParams += `${key}=${filters[key]}` : queryParams += `&${key}=${filters[key]}`);
    }
    const res = await request(`/supplier-calculations/generateReport/${queryParams}`, {method: 'GET'}, dispatch);
    if (res?.hasOwnProperty('errors')) {
        const err = res.errors;
        dispatch(setAlert(err.response.statusText, 'danger'));
        dispatch(unsetLoading());
        return false;
    } else {
        dispatch(unsetLoading());
        return res?.link;
    }
};


export const deleteSupplierTransaction = (transactionId, supplierId, filters = {}) => async (dispatch) => {
    dispatch(clearAlerts());
    try {
        await axios.delete(`/supplier-transactions/${transactionId}/`);
        dispatch(setAlert('Tranzaksiya o\'chirildi!', 'success'));
        dispatch(getSupplierTransactions(supplierId, filters));
        return true;
    } catch (err) {
        dispatch(setAlert('Tranzaksiya o\'chirilmadi!', 'danger'));
        dispatch({
            type: SUPPLIER_TRANSACTION_ERROR,
            payload: err.response.data,
        });
    }
};

export const clearErrors = () => async (dispatch) => {
    dispatch({
        type: CLEAR_ERRORS,
    });
};
